"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const isString_1 = __importDefault(require("lodash/isString"));
const DataTable_styled_1 = require("./DataTable.styled");
const useWindowSize_1 = __importDefault(require("../useWindowSize"));
const constants_1 = __importDefault(require("../utils/constants"));
const stringifyBooleanAndNull = (value) => {
    // We compare booleans like this and without typeof for perf
    return value === true || value === false || value === null ? String(value) : value;
};
const CellContent = ({ cell, open, close }) => {
    const $cell = React.useRef(null);
    const $ghostCell = React.useRef(null);
    const [isTextOverflowing, setIsTextOverflowing] = React.useState(false);
    const { width } = useWindowSize_1.default();
    React.useLayoutEffect(() => {
        if (!$cell.current) {
            return;
        }
        if (!$ghostCell.current) {
            return;
        }
        if (!cell) {
            return;
        }
        if (!isString_1.default(cell)) {
            return;
        }
        setIsTextOverflowing($ghostCell.current.getBoundingClientRect().width >
            $cell.current.getBoundingClientRect().width - constants_1.default.space.content * 2 - DataTable_styled_1.dataTableActionContainerSize);
    }, [width]);
    return (React.createElement(DataTable_styled_1.CellGrid, { ref: $cell, canTruncate: isString_1.default(cell) },
        isString_1.default(stringifyBooleanAndNull(cell)) && isTextOverflowing ? (React.createElement(DataTable_styled_1.CellTruncator, { onMouseEnter: open(stringifyBooleanAndNull(cell)), onMouseLeave: close }, stringifyBooleanAndNull(cell))) : (stringifyBooleanAndNull(cell)),
        React.createElement(DataTable_styled_1.GhostCell, { ref: $ghostCell }, stringifyBooleanAndNull(cell))));
};
exports.default = CellContent;
//# sourceMappingURL=CellContent.js.map